module.exports = __webpack_public_path__ + "img/hk_room_floorplan_10_en.298e1719.png";